<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
  <path fill-rule="evenodd" d="M3 7v10l9 5 9-5V7l-9-5-9 5Zm8 5.588L5 9.255v6.568l6 3.334v-6.569ZM6.089 7.572 12 10.856l5.911-3.284L12 4.288 6.089 7.572Z" clip-rule="evenodd"/>
</svg>
